import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="border-b border-novya-border">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-32">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted">About Novya</div>
          <h1 className="mt-6 font-display font-black text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.9] text-novya-ink max-w-4xl">
            An academy built by people who ship.
          </h1>
          <p className="mt-10 text-lg text-novya-muted max-w-2xl leading-relaxed">
            Novya exists because the gap between "I finished a course" and "I got hired" is where most learners drown. Our programs are designed and taught by working practitioners — engineers, designers, and analysts who spend most of their week shipping code and making decisions inside real companies.
          </p>
        </div>
      </section>

      <section className="border-b border-novya-border">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-novya-border border border-novya-border">
          {[
            { k: "Practitioner-first", v: "Every mentor holds a full-time role. No career educators disconnected from the industry." },
            { k: "Portfolio-graded", v: "Your capstone is reviewed by hiring managers — the exact people you'll interview with next." },
            { k: "Placement-obsessed", v: "310+ hiring partners across India, EU, and US. We measure ourselves on offers, not signups." },
          ].map((x) => (
            <div key={x.k} className="bg-white p-10">
              <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-accent">Principle</div>
              <h3 className="mt-6 font-display font-black text-2xl md:text-3xl tracking-tight text-novya-ink">{x.k}</h3>
              <p className="mt-4 text-novya-muted leading-relaxed">{x.v}</p>
            </div>
          ))}
        </div>
      </section>

      <section>
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32">
          <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95] text-novya-ink max-w-3xl">
            Join the next cohort.
          </h2>
          <div className="mt-10 flex gap-4">
            <Link to="/programs" data-testid="about-programs-btn" className="px-8 py-4 bg-novya-ink text-white font-medium hover:bg-novya-accent transition-colors">
              See programs
            </Link>
            <Link to="/register" data-testid="about-apply-btn" className="px-8 py-4 border border-novya-ink text-novya-ink font-medium hover:bg-novya-ink hover:text-white transition-colors">
              Apply now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
